export const DATE_FORMAT_DISPLAY = "ddd, D MMM";
export const DEFAULT_WINDOW_SIZE_IN_DAYS = 14;
export const MAX_WINDOW_SIZE_IN_DAYS = 90;
export const MIN_WINDOW_SIZE_IN_DAYS = 1;
